import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));
import { getDataByUrl } from "@/handlers/commonApi";
import useIsMobile from "@/hooks/useIsMobile";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  // faqData = null,
  constituencyListData = null,
}) {
  const isMobileDevice = useIsMobile();
  let metaData = {
    title: `Tamil Nadu Election 2026 Date: तमिलनाडु विधानसभा चुनाव की तारीख़, चरणवार वोटिंग और रिजल्ट शेड्यूल - NewsTak`,
    description: `Tamil Nadu Chunav 2026 Schedule: जानें तमिलनाडु विधानसभा चुनाव 2026 की वोटिंग डेट, चरणवार मतदान का पूरा शेड्यूल, नतीजे कब आएंगे और नामांकन की तारीख़ें, पढ़ें Tamil Nadu Election 2026 से जुड़ी हर अपडेट सिर्फ NewsTak पर.`,
    keywords: `Tamil Nadu election 2026 date, Tamil Nadu election schedule 2026, Tamil Nadu vidhan sabha chunav 2026, Tamil Nadu voting date 2026, Tamil Nadu election result date, Tamil Nadu chunav phase 1 2026, Tamil Nadu chunav phase 2 2026, Tamil Nadu election news 2026, तमिलनाडु चुनाव 2026 तारीख, तमिलनाडु विधानसभा चुनाव शेड्यूल`,
  };

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <ElectionPage
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}
          // electionPath={"delhi-assembly/schedule"}
          electionPath={`${electionCategory}/schedule`}

          isMobileDevice={isMobileDevice}
          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="tamil_nadu_election"
          stateName={"Tamil Nadu"} //"Delhi"
          stateHindi={"तमिलनाडु"}
          metaData={metaData}
          constituencyListData={constituencyListData}
          staticContent="चुनाव आयोग ने आगामी तमिलनाडु विधानसभा चुनाव का ऐलान कर दिया है. राज्य की 234 विधानसभा सीटों पर इस बार एक ही फेज में मतदान की प्रक्रिया होगी. तमिलनाडु विधानसभा चुनाव के लिए 23 अप्रैल को वोट डाले जाएंगे. 4 मई को वोटों की गिनती होगी और उसी दिन परिणाम भी आ सकते हैं. मतदान की प्रक्रिया के लिए 30 मार्च को गजट नोटिफिकेशन जारी किया जाएगा. प्रत्याशी 6 अप्रैल तक अपना नामांकन दाखिल करा सकेंगे, वहीं 7 अप्रैल को नामांकन पत्रों की स्क्रूटनी होगी. 9 अप्रैल तक प्रत्याशी अपना नामांकन वापस ले सकते है."
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  let url = ctx?.resolvedUrl;
  url = url.split("/schedule")[0];

  let electionCategory = url.split("/elections/")[1];

  try {
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let electionConfigData = null;
    const electionConfig = await fetch(
      `${process.env.BASE_PATH + process.env.API_PREFIX
      }/masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.tamil_nadu_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2021
        ? electionConfigData?.allConstituency2021Api
        : electionConfigData?.allConstituency2026Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    });

    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 900);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory: electionCategory,
        // faqData,
        constituencyListData
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
